var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_54719",
    clipPath: "url(#clip0_27929_33200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__17_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9724 7.27976L8.80808 17.3312C7.12393 18.9968 4.39312 18.9968 2.70896 17.3312C1.0248 15.6656 1.0248 12.9655 2.70896 11.2999L11.8573 2.2537C12.9803 1.14352 14.8001 1.14352 15.9232 2.2537C17.0462 3.36385 17.0462 5.16441 15.9232 6.27456L6.7748 15.3208C6.21366 15.8763 5.30339 15.8763 4.74152 15.3208C4.18038 14.7661 4.18038 13.8658 4.74152 13.3104L12.8732 5.26933L11.8566 4.26413L3.72562 12.3058C2.60261 13.416 2.60261 15.2166 3.72562 16.3267C4.84863 17.4369 6.66845 17.4369 7.79146 16.3267L16.9398 7.28047C18.624 5.61489 18.624 2.9148 16.9398 1.24919C15.2556 -0.416395 12.5249 -0.416395 10.8407 1.24919L1.18401 10.798L1.219 10.833C-0.535142 13.0633 -0.380933 16.2874 1.69234 18.3371C3.7656 20.3868 7.02469 20.5403 9.2807 18.8047L9.31569 18.8397L19.9883 8.28567L18.9724 7.27976Z",
    fill: "#969BA9"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27929_33200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon2);
export default __webpack_public_path__ + "static/media/ActiveIcon2.783cb3a311251d8595ce09e7845ec79f.svg";
export { ForwardRef as ReactComponent };